/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import * as Sentry from "@sentry/browser";
import Str from "shared/components/Str";
import IdealPersonSvg from "shared/components/svgs/idealperson.svg";
import useUserGuide from "shared/hooks/useUserGuide";
import useLockBodyScroll from "shared/hooks/useLockBodyScroll";
import QuickmatchActions from "reflux/quickmatch/actions/Actions";
import ActionUtil from "shared/util/ActionUtil";

import "./index.scss";

const USER_GUIDE_NAME = "GLOBAL_PREFERENCE_DOUBLETAKE_NAG";
const NUMBER_OF_VOTES_BEFORE_SHOW = 3;

const useRefluxVoteCount = () => {
	const [refluxVoteCount, setRefluxVoteCount] = useState(0);

	useEffect(() => {
		ActionUtil.listen(
			QuickmatchActions.vote,
			() => {
				setRefluxVoteCount((prev) => prev + 1);
				return Promise.resolve();
			},
		);
	}, []);

	return refluxVoteCount;
};

function GlobalPreferenceTooltip({ voteCount }) {
	const [dismissed, setDismissed] = useState(false);
	const {
		hasSeenUserGuide,
		userGuideResponse: { loading, error },
		markUserGuideAsSeen,

		// no-cache in case the user clicks ok and then comes back
	} = useUserGuide(USER_GUIDE_NAME, { fetchPolicy: "no-cache" });
	const refluxVoteCount = useRefluxVoteCount();
	const votedEnough =
		voteCount >= NUMBER_OF_VOTES_BEFORE_SHOW
		|| refluxVoteCount >= NUMBER_OF_VOTES_BEFORE_SHOW;
	const show = !(loading || error || hasSeenUserGuide || dismissed) && votedEnough;

	const stopAndMark = (e) => {
		// prevent profile menu from opening
		e.stopPropagation();

		markUserGuideAsSeen(USER_GUIDE_NAME)
			.catch((err) => Sentry.captureException(err));
	};

	const dismissAndMarkAsSeen = (e) => {
		stopAndMark(e);

		setDismissed(true);
	};

	useLockBodyScroll(show);

	if (!show) {
		return null;
	}

	return (
		<>
			<div
				className="global-preferences-tooltip-overlay"
				onClick={dismissAndMarkAsSeen}
			/>
			<CSSTransition
				in
				appear
				classNames="gp-tooltip-transition"
				unmountOnExit
				timeout={300}
			>
				<div
					className="global-preferences-tooltip"
					role="alertdialog"
					onClick={(e) => e.stopPropagation()}
				>
					<button
						className="global-preferences-tooltip-close"
						onClick={dismissAndMarkAsSeen}
					>
						<span className="icon" />
					</button>
					<div className="global-preferences-tooltip-notice">
						<Str>New Feature!</Str>
					</div>
					<IdealPersonSvg className="global-preferences-tooltip-icon" />
					<Str className="global-preferences-tooltip-title">Match on what matters</Str>
					<Str className="global-preferences-tooltip-text">Find your ideal person by setting your preferences.</Str>
					<Link
						onClick={dismissAndMarkAsSeen}
						className="global-preferences-tooltip-action"
						to="/profile?globalpreferences=1"
					>
						<Str>Ok</Str>
					</Link>
				</div>
			</CSSTransition>
		</>
	);
}

GlobalPreferenceTooltip.propTypes = {
	voteCount: PropTypes.number.isRequired,
};

export default GlobalPreferenceTooltip;



// WEBPACK FOOTER //
// ./src/shared/components/GlobalPreferenceTooltip/index.jsx